(() => {
  const euroPrice = /€\s*((?:\d{1,3}(?:\.\d{3})*|\d+)),(\d{2})/g;

  function normalizeTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue || !node.nodeValue.includes('€')) return;
    const parent = node.parentElement;
    if (parent && /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/i.test(parent.tagName)) return;
    node.nodeValue = node.nodeValue.replace(euroPrice, (_match, whole, cents) => {
      const normalizedWhole = whole.includes('.') ? whole.replace(/\./g, ',') : whole;
      return `€${normalizedWhole}.${cents}`;
    });
  }

  function normalizeTree(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) normalizeTextNode(node);
  }

  function start() {
    normalizeTree(document.body);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') normalizeTextNode(mutation.target);
        mutation.addedNodes.forEach(normalizeTree);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();